"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var createGradient = function createGradient() {
  for (var _len = arguments.length, steps = new Array(_len), _key = 0; _key < _len; _key++) {
    steps[_key] = arguments[_key];
  }

  return "linear-gradient(to bottom left, ".concat(steps.join(', '), ")");
};

var _default = createGradient;
exports["default"] = _default;